module.exports = __webpack_public_path__ + "img/zhouchang.fb654477.png";